import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  dialog: {
    width: '100%',
    maxWidth: 1200,
    padding: theme.spacing(12),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    backgroundColor: theme.colorPalette.beige_25
  },
  backLink: {
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    cursor: 'pointer',
    color: theme.colorPalette.orange_50,
    fontSize: 14,
    fontWeight: 600
  },
  backIcon: {
    width: 24,
    height: 24
  },
  content: {
    display: 'flex',
    flexDirection: 'column'
  },
  contentLabel: {
    color: theme.colorPalette.green_100,
    fontSize: 14,
    fontWeight: 400
  },
  button: {
    fontSize: 16,
    fontWeight: 600,
    padding: theme.spacing(0, 4)
  },
  buttonContainer: {
    marginTop: theme.spacing(6)
  },
  submit: {
    width: 160
  },
  notesContainer: {
    marginTop: theme.spacing(6)
  },
  notification: {
    margin: theme.spacing(6, 0),
    boxShadow: 'none'
  },
  reviewLink: {
    color: theme.colorPalette.orange_50,
    display: 'inline-block',
    textDecoration: 'underline',
    marginLeft: theme.spacing(1),
    '&:hover': {
      textDecoration: 'none',
      cursor: 'pointer'
    }
  },
  infoIconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  infoIcon: {
    width: 16,
    height: 16
  },
  infoText: {
    marginLeft: theme.spacing(6)
  }
});

export default makeStyles(styles);
